import { takeEvery, put, call } from "redux-saga/effects";

// Chat Redux States
import {
  DELETE_MESSAGE,
  GET_CHATS,
  GET_CONTACTS,
  GET_GROUPS,
  GET_MESSAGES,
  POST_ADD_MESSAGE,
} from "./actionTypes";
import {
  getChatsSuccess,
  getChatsFail,
  getGroupsSuccess,
  getGroupsFail,
  getContactsSuccess,
  getContactsFail,
  getMessagesSuccess,
  getMessagesFail,
  addMessageSuccess,
  addMessageFail,
  deleteMessageSuccess,
  deleteMessageFail,
} from "./actions";

//Include Both Helper File with needed methods
import {
  getChats,
  getGroups,
  getContacts,
  getMessages,
  addMessage,
  deleteMessage,
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";

function* onGetChats(): Generator<any, void, any> {
  try {
    const response = yield call(getChats);
    yield put(getChatsSuccess(response));
  } catch (error) {
    yield put(getChatsFail(error));
  }
}

function* onGetGroups(): Generator<any, void, any> {
  try {
    const response = yield call(getGroups);
    yield put(getGroupsSuccess(response));
  } catch (error) {
    yield put(getGroupsFail(error));
  }
}

function* onGetContacts(): Generator<any, void, any> {
  try {
    const response = yield call(getContacts);
    yield put(getContactsSuccess(response));
  } catch (error) {
    yield put(getContactsFail(error));
  }
}

interface GetMessagesAction {
  type: string;
  roomId: string | number;
}

interface AddMessageAction {
  type: string;
  message: any;
}

interface DeleteMessageAction {
  type: string;
  payload: any;
}

function* onGetMessages(action: GetMessagesAction): Generator<any, void, any> {
  try {
    const response = yield call(getMessages as any, action.roomId);
    yield put(getMessagesSuccess(response));
  } catch (error) {
    yield put(getMessagesFail(error));
  }
}

function* onAddMessage(action: AddMessageAction): Generator<any, void, any> {
  try {
    const response = yield call(addMessage, action.message);
    yield put(addMessageSuccess(response));
  } catch (error) {
    yield put(addMessageFail(error));
  }
}

function* OnDeleteMessage(action: DeleteMessageAction): Generator<any, void, any> {
  try {
    const response = yield call(deleteMessage, action.payload)
    yield put(deleteMessageSuccess(response))
    toast.success("Message Deleted Successfully", { autoClose: 2000 });
  } catch (error) {
    yield put(deleteMessageFail(error))
    toast.error("Message Deleted Failed", { autoClose: 2000 });
  }
}

function* chatSaga(): Generator<any, void, any> {
  yield takeEvery(GET_CHATS as any, onGetChats);
  yield takeEvery(GET_GROUPS as any, onGetGroups);
  yield takeEvery(GET_CONTACTS as any, onGetContacts);
  yield takeEvery(GET_MESSAGES as any, onGetMessages);
  yield takeEvery(POST_ADD_MESSAGE as any, onAddMessage);
  yield takeEvery(DELETE_MESSAGE as any, OnDeleteMessage);

}

export default chatSaga;
